import {
  CollaboratorExpense,
  EstimateMatrixRow,
} from 'interfaces/CollaboratorExpense';
import {
  CreateYearParams,
  StartYearParams,
  UpsertCellParams,
  applyFromMonth,
  createYear,
  grid,
  matrix,
  startYear,
  upsertCell,
} from './calls';

export * from './calls';

export default class CollaboratorExpenseAPICaller {
  static grid = async (collaboratorId: string, year: number) => {
    const {
      data: { expenses },
    } = await grid(collaboratorId, year);

    return expenses as CollaboratorExpense[];
  };

  static matrix = async (year: number, costCenterId?: string) => {
    const {
      data: { rows },
    } = await matrix(year, costCenterId);

    return rows as EstimateMatrixRow[];
  };

  static createYear = async (params: CreateYearParams) => {
    const {
      data: { expenses },
    } = await createYear(params);

    return expenses as CollaboratorExpense[];
  };

  static upsertCell = async (params: UpsertCellParams) => {
    const { data } = await upsertCell(params);

    return data as CollaboratorExpense;
  };

  static applyFromMonth = async (params: UpsertCellParams) => {
    const {
      data: { expenses },
    } = await applyFromMonth(params);

    return expenses as CollaboratorExpense[];
  };

  static startYear = async (params: StartYearParams) => {
    const {
      data: { expenses },
    } = await startYear(params);

    return expenses as CollaboratorExpense[];
  };
}
